import { createSlice } from "@reduxjs/toolkit";

import { STATUS } from "../../../config/constants";

const initialState = {
  status: STATUS.NONE,
};

export const deletePlansSlice = createSlice({
  name: "deletePlans",
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state) => {
      state.status = STATUS.SUCCESS;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
  },
});

export const { resetState, readyForNextState, request, success, failure } =
  deletePlansSlice.actions;

export const status = (state) => state.deletePlans.status;

export const error = (state) => state.deletePlans.error;

export default deletePlansSlice.reducer;
